import {
    Box,
    Button,
    Container,
    Divider,
    Grid,
    Group,
    Image,
    Input,
    Text,
    ThemeIcon,
    Title,
    useMantineTheme,
    Overlay,
    ActionIcon,
    Modal,
    NativeSelect,
} from "@mantine/core";
import { connect } from "react-redux";
import { FormInputWrapper } from "../../../../core/components";
import { selectTalent, updateTalentSuccess } from "../../talentSlice";
import { AppConstants, Genders } from "../../../../utils/constants";
import { logger } from "utils/logger";
import React, { useEffect, useState } from "react";
import { TalentStatuses } from "core/models/TalentModel";
import { IconFile, IconTrash } from "@tabler/icons-react";
import { downloadFile } from "utils/helper";
import CaptureDetail from "core/components/capture/CaptureDetail";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles((theme, _params, getRef) => ({
  preview: {
    ".overlay": {
      opacity: 0,
    },
    "&:hover": {
      ".overlay": {
        opacity: 0.5,
      },
      ".btn-clear": {
        opacity: 1,
        marginTop: 0,
      },
    },
    ".btn-clear": {
      opacity: 0,
      marginTop: 10,
      transition: "all .2s ease-in-out",
    },
  },
}));

const TalentTabGeneral = ({
  user,
  talent,
  success,
  error,
  form,
  onFormSubmit,
}) => {
  const theme = useMantineTheme();
  const enabled = true;

  const [isSaving, setIsSaving] = useState(false);
  const [files, setFiles] = useState([]);
  const [assetFiles, setAssetFiles] = useState([]);
  const { classes } = useStyles();
  const [selectedItem, setSelectedItem] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  useEffect(() => {
    if (success) {
      switch (success.type) {
        case updateTalentSuccess.toString(): {
          setIsSaving(false);
          break;
        }
        default: {
          break;
        }
      }
    }
  }, [success]);

  const previews = files.map((file, index) => {
    return (
      <Group key={index} position="apart" mt={"lg"} mb={"sm"}>
        <Group spacing={"xs"}>
          <ThemeIcon radius="xl">
            <IconFile size={16} />
          </ThemeIcon>
          <Text size={"sm"}>{file.name}</Text>
        </Group>
        <Button variant="subtle" onClick={() => setFiles([])}>
          Remove
        </Button>
      </Group>
    );
  });

  const zoomImage = (data) => {
    logger.log(data);
    setSelectedItem(data);
    setImageModalOpen(true);
  };
  const assetPreviews = talent?.images.map((file, index) => {
    return (
      <React.Fragment key={index}>
        {/* <ImagePreview file={file} onClick={zoomImage} /> */}
      </React.Fragment>
    );
  });

  const imagePreviews = assetFiles.map((file, index) => {
    const imageUrl = file.url ? file.url : URL.createObjectURL(file);
    return (
      <Group
        key={index}
        className={classes.preview}
        sx={{ position: "relative" }}
        align="center"
        position="center"
      >
        <Image
          fit="contain"
          key={index}
          src={imageUrl}
          className={classes.image}
          alt={file.name}
          height={200}
          withPlaceholder
          onLoad={() => URL.revokeObjectURL(imageUrl)}
        />
        <Overlay className="overlay" color="#000" />
        <ActionIcon
          variant="filled"
          radius={"xl"}
          size={"xl"}
          className="btn-clear"
          sx={{ position: "absolute", zIndex: 9999 }}
          onClick={() => {
            var assets = [...assetFiles];
            assets.splice(index, 1);
            setAssetFiles([...assets]);
          }}
        >
          <IconTrash />
        </ActionIcon>
      </Group>
    );
  });

  const downloads = talent?.files.map((file, idx) => {
    return (
      <Group key={idx} position="apart" mt={0} mb={"sm"}>
        <Group spacing={"xs"}>
          <ThemeIcon radius="xl">
            <IconFile size={16} />
          </ThemeIcon>
          <Text size={"sm"}>Comp Card</Text>
        </Group>
        <Button
          variant="subtle"
          onClick={() => downloadFile(file.path, "comp.pdf")}
        >
          Download
        </Button>
      </Group>
    );
  });

  // const containerTalent = { width:'1000px', marginTop:'20%', paddingLeft:'20%'}
  return (
    <Container fluid sx={{ marginLeft: 0 }}>
      <Grid>
        <Grid.Col span={8}>
          <Box p="xl">
            <Title order={5} mb="lg">
              General Details
            </Title>

            <form
              onSubmit={form.onSubmit((values) => {
                setIsSaving(true);
                const payload = {
                  ...values,
                  files: files,
                  assetFiles: assetFiles,
                };
                onFormSubmit(payload);
              })}
            >
              <FormInputWrapper label="First Name" id="input-first">
                <Input
                  disabled={!enabled}
                  id="input-first"
                  required
                  placeholder="Enter First Name"
                  variant={AppConstants.inputVariant}
                  {...form.getInputProps("first")}
                />
              </FormInputWrapper>

              <FormInputWrapper label="Last Name" id="input-last">
                <Input
                  disabled={!enabled}
                  id="input-last"
                  required
                  placeholder="Enter Last Name"
                  variant={AppConstants.inputVariant}
                  {...form.getInputProps("last")}
                />
              </FormInputWrapper>

              <FormInputWrapper label="Agency" id="input-agency">
                <Input
                  disabled={!enabled}
                  id="input-agency"
                  placeholder="Enter Agency"
                  variant={AppConstants.inputVariant}
                  {...form.getInputProps("agency")}
                />
              </FormInputWrapper>

              <FormInputWrapper label="Age" id="input-age">
                <Input
                  sx={{ width: 200 }}
                  disabled={!enabled}
                  id="input-age"
                  placeholder="Enter Age"
                  variant={AppConstants.inputVariant}
                  {...form.getInputProps("age")}
                />
              </FormInputWrapper>

              <FormInputWrapper label="Gender" id="input-gender">
                <NativeSelect
                  sx={{ width: 200 }}
                  disabled={!enabled}
                  id="input-gender"
                  data={Genders}
                  placeholder="Enter Gender"
                  variant={AppConstants.inputVariant}
                  {...form.getInputProps("gender")}
                />
              </FormInputWrapper>

              <FormInputWrapper label="Status" id="input-status">
                <NativeSelect
                  sx={{ width: 200 }}
                  disabled={!enabled}
                  id="input-status"
                  data={TalentStatuses}
                  required
                  placeholder="Enter status"
                  variant={AppConstants.inputVariant}
                  {...form.getInputProps("status")}
                />
              </FormInputWrapper>

              {/* <FormInputWrapper
                                label='Completed'
                                id='input-completed'
                                talent={{
                                    marginTop: theme.spacing.xl,
                                    marginBottom: theme.spacing.xl,
                                }}>
                                <Text size={'sm'}>{moment(jsDate).format(DataFormats.DATE_FORMAT)}</Text>
                            </FormInputWrapper> */}

              {/* <FormInputWrapper label='Shoot Date' id='input-shootdate'>
                                <Group>
                                    <CustomDatePicker sx={{ width: 200 }} placeholder='Completed Date' {...form.getInputProps('completed')} />
                                </Group>
                            </FormInputWrapper> */}

              
              <Group position="right">
                <Button type="submit" loading={isSaving}>
                  Update Talent
                </Button>
              </Group>
            </form>
          </Box>
        </Grid.Col>
        <Grid.Col span={3}>
          <Box my={"lg"} className={`info-panel unhightable`}>
            <Group align="center" position="apart" mb="sm">
              <Title order={5}>Latest Capture</Title>
              {/* <Badge size='md'>
                                {checklistItems.filter((val) => val.value).length} / {checklistItems.length}
                            </Badge> */}
            </Group>
            <Divider />
            {/* <ImagePreview
              file={{ url: talent?.latestURL }}
              onClick={zoomImage}
              height={"auto"}
            /> */}
            {/* <Image src={talent?.latestURL} /> */}
            {/* <CaptureThumb
                            showSettings={false}
                            src={talent?.latestURL}
                            image={{originalFilename:'none'}}
                            // onImageEvent={onImageEvent}
                            size={100}
                            // selected={isSelected(val, selectedItems)}
                            // onCaptureChange={(type, val) =>
                            //   onCaptureChange(type, val, [data])
                            // }
                        /> */}
          </Box>
          {/* <Group>
                    {talent?.images.map((val) => {
                        return (
                           <Box>
                                <Image  src={val.url} />
                            </Box>
                            
                        );
                    })}
                    </Group> */}
        </Grid.Col>
      </Grid>

      <Modal
        opened={imageModalOpen}
        size={"lg"}
        title={`${selectedItem?.originalFilename}`}
        trapFocus={true}
        fullScreen
        onClose={() => setImageModalOpen(false)}
      >
        <CaptureDetail
          showSettings={false}
          resoloveImage={false}
          image={selectedItem}
          src={selectedItem?.previewHi}
          onImageEvent={() => logger.log("On image event")}
          onCaptureChange={() => {}}
        />
      </Modal>
    </Container>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    talent: state.talentReducer.selectedTalent,
    // success: state.auth.success,
    // error: state.auth.error,
  };
};

const mapDispatch = { selectTalent };

export default connect(mapStateToProps, mapDispatch)(TalentTabGeneral);

// const ImagePreview = ({ file, onClick, height = 200 }) => {
//     const { classes } = useStyles();
//     const [isLoading, setIsLoading] = useState(true);

//     return (
//         <Group className={classes.preview} sx={{ position: 'relative', minWidth:180 }} align='center' position='center' onClick={() => onClick({ previewHi: file.url, originalFilename: file.name })}>

//             {isLoading ? (
//                 <Skeleton width={180} height={height} sx={{position:'absolute', zIndex:1}} />
//             ) : (
//                 null
//             )}

//             <Image
//                 fit='contain'
//                 src={file.url}
//                 className={classes.image}
//                 alt={file.name}
//                 height={height}
//                 withPlaceholder
//                 onLoadCapture={(e) => {
//                     setIsLoading(false);
//                 }}
//             />

//             <Overlay className='overlay' color='#000' />
//             <ActionIcon variant='filled' radius={'xl'} size={'xl'} className='btn-clear' sx={{ position: 'absolute', zIndex: 9999 }}>
//                 <IconZoomIn />
//             </ActionIcon>
//         </Group>
//     );
// };
